/**
 * 页面文案词典 —— 中文（源语言）
 * 第三批：控制台首屏 + 充值管理（资金页）
 */
export default {
  // ---- 控制台 Dashboard ----
  '当前在线': '当前在线',
  '今日活跃': '今日活跃',
  '近 7 天活跃': '近 7 天活跃',
  '今日短信请求': '今日短信请求',
  '总用户数': '总用户数',
  '文章总数': '文章总数',
  '总浏览量': '总浏览量',
  '企业数': '企业数',
  '分类数': '分类数',
  '敏感词': '敏感词',
  '最近活动': '最近活动',
  '暂无活动': '暂无活动',
  '热门文章': '热门文章',
  '最近交易记录': '最近交易记录',
  '付款企业': '付款企业',
  '收款企业': '收款企业',
  '暂无交易记录': '暂无交易记录',
  '次浏览': '次浏览',

  // ---- 充值管理 Recharge ----
  '待支付': '待支付',
  '已到账': '已到账',
  '支付失败': '支付失败',
  '已关闭': '已关闭',
  '已退款': '已退款',
  '请选择企业': '请选择企业',
  '请输入正确的金额': '请输入正确的金额',
  '授信': '授信',
  '充值': '充值',
  '关闭充值单': '关闭充值单',
  '后台关闭': '后台关闭',
  '冲正（退款）': '冲正（退款）',
  '后台冲正': '后台冲正',
  '已冲正': '已冲正',
  '导出成功': '导出成功',
  '导出失败': '导出失败',
  '导出CSV': '导出CSV',
  '订单号': '订单号',
  '渠道': '渠道',
  '性质': '性质',
  '实收': '实收',
  '用途': '用途',
  '渠道流水号': '渠道流水号',
  '操作人': '操作人',
  '到账时间': '到账时间',
  '冲正': '冲正',
  '累计充值笔数': '累计充值笔数',
  '累计到账金额': '累计到账金额',
  '按渠道': '按渠道',
  '给企业充值 / 授信': '给企业充值 / 授信',
  '给企业钱包充值 / 授信': '给企业钱包充值 / 授信',
  '确认到账': '确认到账',
  '目标企业': '目标企业',
  '输入企业名称 / 联系人搜索': '输入企业名称 / 联系人搜索',
  '充值性质': '充值性质',
  '充值渠道': '充值渠道',
  '平台授信': '平台授信',
  '平台充值': '平台充值',

  // ---- 交易记录 Transactions ----
  '方向': '方向',
  '转入': '转入',
  '转出': '转出',
  '转账': '转账',
  '交易对手': '交易对手',
  '交易时间': '交易时间',
  '交易日期': '交易日期',
  '总交易笔数': '总交易笔数',
  '总转入金额': '总转入金额',
  '总转出金额': '总转出金额',
  '转入笔数': '转入笔数',
  '转出笔数': '转出笔数',
  '搜索付款企业或收款企业名称': '搜索付款企业或收款企业名称',

  // ---- 提现审核 Withdrawal ----
  '已完成': '已完成',
  '已通过': '已通过',
  '请填写驳回原因': '请填写驳回原因',
  '银行户名': '银行户名',
  '银行账号': '银行账号',
  '开户行': '开户行',
  '审核备注': '审核备注',
  '审核人': '审核人',
  '处理时间': '处理时间',
  '申请时间': '申请时间',
  '总提现': '总提现',
  '通过提现': '通过提现',
  '驳回提现': '驳回提现',
  '审核备注（可选）': '审核备注（可选）',
  '请输入驳回原因（必填）': '请输入驳回原因（必填）',

  // ---- 我的企业官网 MyWebsite ----
  '抖音': '抖音',
  '小红书': '小红书',
  '视频号': '视频号',
  '快手': '快手',
  '平台': '平台',
  '图片已上传': '图片已上传',
  '请先绑定抖音': '请先绑定抖音',
  '已保存，企业官网内容已更新': '已保存，企业官网内容已更新',
  '请先粘贴至少一个链接': '请先粘贴至少一个链接',
  '没有识别到任何链接，请检查粘贴的内容': '没有识别到任何链接，请检查粘贴的内容',
  '请至少勾选一项': '请至少勾选一项',
  '识别到的名称': '识别到的名称',
  '最终地址': '最终地址',
  '主页': '主页',
  '作品': '作品',
  '已获取信息': '已获取信息',
  '仅链接': '仅链接',
  '需上传二维码': '需上传二维码',
  '操作建议': '操作建议',
  '已开通，展示中': '已开通，展示中',
  '已被管理员暂停展示': '已被管理员暂停展示',
  '尚未开通': '尚未开通',
  '副标题': '副标题',
  '主标题': '主标题',
  '编辑官网内容': '编辑官网内容',
  '当前已被管理员暂停展示': '当前已被管理员暂停展示',
  '抖音用户': '抖音用户',
  '已过期': '已过期',
  '已绑定': '已绑定',
  '绑定抖音': '绑定抖音',
  '用昵称头像填充抖音格子': '用昵称头像填充抖音格子',
  '确定解绑抖音吗？': '确定解绑抖音吗？',
  '请联系平台管理员开通': '请联系平台管理员开通',
  '上传失败': '上传失败',
  '复制失败，请手动选中后复制': '复制失败，请手动选中后复制',
  '嵌入代码已复制，可直接粘贴到官网': '嵌入代码已复制，可直接粘贴到官网',
};
